module.exports = __webpack_public_path__ + "static/media/6.57f44ae1.png";